var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnrollCourse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 63,
    viewBox: "0 0 68 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13341",
    "data-name": "Group 13341",
    transform: "translate(-334 -5296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13340",
    "data-name": "Group 13340"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 68,
    height: 63,
    rx: 12,
    transform: "translate(334 5296)",
    fill: "#3488eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13079",
    "data-name": "Group 13079",
    transform: "translate(336.907 5293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3970",
    "data-name": "Path 3970",
    d: "M19.92,21.531A1.531,1.531,0,0,0,18.389,20H14.531A1.531,1.531,0,0,0,13,21.531v3.858a1.531,1.531,0,0,0,1.531,1.531h3.858a1.531,1.531,0,0,0,1.531-1.531Zm-1.142,3.895a.353.353,0,0,1-.353.353H14.566a.353.353,0,0,1-.353-.353V21.566a.353.353,0,0,1,.353-.353h3.859a.353.353,0,0,1,.353.353Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3971",
    "data-name": "Path 3971",
    d: "M125.92,21.531A1.531,1.531,0,0,0,124.389,20h-3.858A1.531,1.531,0,0,0,119,21.531v3.858a1.531,1.531,0,0,0,1.531,1.531h3.858a1.531,1.531,0,0,0,1.531-1.531Zm-1.142,3.895a.353.353,0,0,1-.353.353h-3.859a.353.353,0,0,1-.353-.353V21.566a.353.353,0,0,1,.353-.353h3.859a.353.353,0,0,1,.353.353Z",
    transform: "translate(-98.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3972",
    "data-name": "Path 3972",
    d: "M19.92,142.531A1.531,1.531,0,0,0,18.389,141H14.531A1.531,1.531,0,0,0,13,142.531v3.858a1.531,1.531,0,0,0,1.531,1.531h3.858a1.531,1.531,0,0,0,1.531-1.531Zm-1.142,3.895a.353.353,0,0,1-.353.353H14.566a.353.353,0,0,1-.353-.353v-3.859a.353.353,0,0,1,.353-.353h3.859a.353.353,0,0,1,.353.353Z",
    transform: "translate(0 -112.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    "data-name": "Path 3973",
    d: "M19.92,262.531A1.531,1.531,0,0,0,18.389,261H14.531A1.531,1.531,0,0,0,13,262.531v3.858a1.531,1.531,0,0,0,1.531,1.531h3.858a1.531,1.531,0,0,0,1.531-1.531Zm-1.142,3.895a.353.353,0,0,1-.353.353H14.566a.353.353,0,0,1-.353-.353v-3.859a.353.353,0,0,1,.353-.353h3.859a.353.353,0,0,1,.353.353Z",
    transform: "translate(0 -223.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3974",
    "data-name": "Path 3974",
    d: "M19.92,382.531A1.531,1.531,0,0,0,18.389,381H14.531A1.531,1.531,0,0,0,13,382.531v3.858a1.531,1.531,0,0,0,1.531,1.531h3.858a1.531,1.531,0,0,0,1.531-1.531Zm-1.142,3.895a.353.353,0,0,1-.353.353H14.566a.353.353,0,0,1-.353-.353v-3.859a.353.353,0,0,1,.353-.353h3.859a.353.353,0,0,1,.353.353Z",
    transform: "translate(0 -335.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3975",
    "data-name": "Path 3975",
    d: "M290.92,21.531A1.531,1.531,0,0,0,289.389,20h-3.858A1.531,1.531,0,0,0,284,21.531v3.858a1.531,1.531,0,0,0,1.531,1.531h3.858a1.531,1.531,0,0,0,1.531-1.531Zm-1.142,3.895a.353.353,0,0,1-.353.353h-3.859a.353.353,0,0,1-.353-.353V21.566a.353.353,0,0,1,.353-.353h3.859a.353.353,0,0,1,.353.353Z",
    transform: "translate(-251.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3976",
    "data-name": "Path 3976",
    d: "M396.92,21.531A1.531,1.531,0,0,0,395.389,20h-3.858A1.531,1.531,0,0,0,390,21.531v3.858a1.531,1.531,0,0,0,1.531,1.531h3.858a1.531,1.531,0,0,0,1.531-1.531Zm-1.213,3.895a.353.353,0,0,1-.353.353h-3.859a.353.353,0,0,1-.353-.353V21.566a.353.353,0,0,1,.353-.353h3.859a.353.353,0,0,1,.353.353Z",
    transform: "translate(-350.103)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    "data-name": "Path 3977",
    d: "M396.92,142.531A1.531,1.531,0,0,0,395.389,141h-3.858A1.531,1.531,0,0,0,390,142.531v3.858a1.531,1.531,0,0,0,1.531,1.531h3.858a1.531,1.531,0,0,0,1.531-1.531Zm-1.213,3.895a.353.353,0,0,1-.353.353h-3.859a.353.353,0,0,1-.353-.353v-3.859a.353.353,0,0,1,.353-.353h3.859a.353.353,0,0,1,.353.353Z",
    transform: "translate(-350.103 -112.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3978",
    "data-name": "Path 3978",
    d: "M396.92,382.531A1.531,1.531,0,0,0,395.389,381h-3.858A1.531,1.531,0,0,0,390,382.531v3.858a1.531,1.531,0,0,0,1.531,1.531h3.858a1.531,1.531,0,0,0,1.531-1.531Zm-1.213,3.895a.353.353,0,0,1-.353.353h-3.859a.353.353,0,0,1-.353-.353v-3.859a.353.353,0,0,1,.353-.353h3.859a.353.353,0,0,1,.353.353Z",
    transform: "translate(-350.103 -335.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3979",
    "data-name": "Path 3979",
    d: "M133.589,147.051a2.293,2.293,0,0,0-1.713.278,2.531,2.531,0,0,0-.436-.128,2.3,2.3,0,0,0-1.75.362c-.077.053-.152.108-.222.165a2.711,2.711,0,0,0-1.713.309l-1.494-2.191a2.678,2.678,0,0,0-.341-.454v-2.85A1.547,1.547,0,0,0,124.381,141h-3.847A1.542,1.542,0,0,0,119,142.542v3.847a1.534,1.534,0,0,0,1.534,1.531h1.521a2.7,2.7,0,0,0,.35.589l2.868,4.2a3.75,3.75,0,0,0-.434,1,4.5,4.5,0,0,0,.843,3.793,6.831,6.831,0,0,0,4.38,2.943,5.778,5.778,0,0,0,4.231-.781,9.643,9.643,0,0,0,2.947-2.823,5.5,5.5,0,0,0-.153-5.864C135.548,148.266,134.938,147.363,133.589,147.051Zm-.048,11.517a5.033,5.033,0,0,1-6.763-1.815,3.169,3.169,0,0,1-.635-2.769l1.159,1.695a.665.665,0,0,0,1.1-.751l-4.911-7.187c-.034-.046-.886-1.169.009-1.781.524-.359.931-.433,1.663.637l2.461,3.6a1.275,1.275,0,0,1,.565-.866,1.462,1.462,0,0,1,1.123-.279,1.439,1.439,0,0,1,.578.259,1.409,1.409,0,0,1,.554-.648.964.964,0,0,1,.744-.154,1.839,1.839,0,0,1,.883.524,1.016,1.016,0,0,1,.4-.5,1,1,0,0,1,.825-.184c.722.167,1.1.565,2.64,3.288C138.093,155.454,135.019,157.557,133.541,158.568Z",
    transform: "translate(-98.438 -112.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    "data-name": "Path 3980",
    d: "M289.673,389.721a.344.344,0,0,1,.036.18v3.839a.308.308,0,0,1-.344.3h-3.839a.282.282,0,0,1-.312-.3V391.9c-.285.025-.514.038-.766.038-.143,0-.3-.006-.447-.014v1.815a1.513,1.513,0,0,0,1.525,1.514h3.839a1.54,1.54,0,0,0,1.556-1.514V389.9a1.564,1.564,0,0,0-.385-1,9.966,9.966,0,0,1-.864.825Z",
    transform: "translate(-251.667 -342.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    "data-name": "Path 3981",
    d: "M124.732,381.061a1.537,1.537,0,0,0-.353-.061H120.54a1.572,1.572,0,0,0-1.54,1.568v3.839a1.526,1.526,0,0,0,1.54,1.514h3.839a1.527,1.527,0,0,0,1.541-1.514v-3.839c0-.039-.008-.087-.011-.125A8.784,8.784,0,0,1,124.732,381.061Zm.047,5.365a.353.353,0,0,1-.353.353h-3.859a.353.353,0,0,1-.353-.353v-3.859a.353.353,0,0,1,.353-.353h3.859a.353.353,0,0,1,.353.353Z",
    transform: "translate(-98.438 -335.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3982",
    "data-name": "Path 3982",
    d: "M120.54,267.92h3.3a5.3,5.3,0,0,1-.274-1.213H120.54a.319.319,0,0,1-.327-.333v-3.839a.311.311,0,0,1,.327-.323h1.965L121.7,261H120.54a1.544,1.544,0,0,0-1.54,1.535v3.839A1.553,1.553,0,0,0,120.54,267.92Z",
    transform: "translate(-98.438 -223.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3983",
    "data-name": "Path 3983",
    d: "M289.364,146.636h-.636a9.109,9.109,0,0,1,1.041,1.155,1.509,1.509,0,0,0,1.151-1.449V142.5a1.531,1.531,0,0,0-1.556-1.5h-3.839A1.5,1.5,0,0,0,284,142.5v3.485c.071,0,.148-.008.224-.008a3.524,3.524,0,0,1,.673.065c.036.007.092.015.128.023a1.7,1.7,0,0,1,.188-.063v-3.5a.274.274,0,0,1,.312-.29h3.839c.192,0,.344.1.344.29v3.839c0,.191-.152.294-.344.294Z",
    transform: "translate(-251.666 -112.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3984",
    "data-name": "Path 3984",
    d: "M395.325,261h-3.839a1.535,1.535,0,0,0-1.5,1.253,7.251,7.251,0,0,1,.839,3.673,6.286,6.286,0,0,1-.308,1.635,1.531,1.531,0,0,0,.974.358h3.839a1.587,1.587,0,0,0,1.578-1.546v-3.839A1.578,1.578,0,0,0,395.325,261Zm.365,5.426a.353.353,0,0,1-.353.353h-3.859a.353.353,0,0,1-.353-.353v-3.859a.353.353,0,0,1,.353-.353h3.859a.353.353,0,0,1,.353.353Z",
    transform: "translate(-350.087 -223.806)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollCourse);
export default __webpack_public_path__ + "static/media/enroll-course.8d5292965d456b5a4c7df82e7bd8137a.svg";
export { ForwardRef as ReactComponent };